import {Component, Inject} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataEntity} from 'octopus-connect';
import {Observable} from 'rxjs';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-feedback-dialog',
    templateUrl: 'feedback-dialog.component.html',
    animations: [
        trigger('fadeInAndOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('100ms ease-in-out', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('100ms ease-in-out', style({ opacity: 0 })),
            ]),
        ]),
    ],
})

export class FeedbackDialogComponent {

    public form = this.fb.group({
        grade: [''],
        recommendation: [''],
        before: [null],
        after: [null],
        feedback: [''],
        genre: '',
    });

    constructor(
        public selfDialogRef: MatDialogRef<FeedbackDialogComponent>,
        private fb: UntypedFormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: {
            save: (data) => Observable<DataEntity>,
            idLesson?: string,
            activity?: string
        }
    ) {

    }


    onSubmit(): void {
        const myFeedback = {
            grade: this.form.value.grade,
            recommendation: this.form.value.recommendation,
            before: this.form.value.before,
            after: this.form.value.after,
            feedback: this.form.value.feedback,
            genre: this.form.value.genre,
        };

        /*        if (this.data?.idLesson && this.data?.activity) {
                    myFeedback['activity'] = this.data?.activity;
                }*/

        this.data.save(myFeedback).subscribe((data) => {
            this.selfDialogRef.close();
        }, error => {
            console.log('error = ', error);
        });

    }

    accept(): void {
        this.selfDialogRef.close(true);
    }

    cancel(): void {
        this.selfDialogRef.close(false);
    }
}